// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__CLYHD","title":"Navbar_title__1Do-7","display-name":"Navbar_display-name__ZAfeF","register":"Navbar_register__1Pwvh"};